import { useEffect } from 'react';
import { useStoreSettings } from '../../../hooks/useStoreSettings';

const StructuredData = ({ pageType = 'home', product = null }) => {
    const { storeSettings, loading } = useStoreSettings();

    useEffect(() => {
        if (loading || !storeSettings) return;

        const storeName = storeSettings.name || 'Online Store';
        const storeDescription = storeSettings.description || 'Premium ecommerce store';
        const logoUrl = storeSettings.logoUrl || '';
        const currentUrl = window.location.href;

        let structuredData = null;

        if (pageType === 'home') {
            // Organization structured data for homepage
            structuredData = {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": storeName,
                "description": storeDescription,
                "url": currentUrl,
                "logo": logoUrl,
                "contactPoint": {
                    "@type": "ContactPoint",
                    "telephone": storeSettings.phone || "",
                    "contactType": "Customer Service",
                    "email": storeSettings.email || ""
                },
                "sameAs": [
                    storeSettings.socialMedia?.instagram || "",
                    storeSettings.socialMedia?.facebook || "",
                    storeSettings.socialMedia?.twitter || ""
                ].filter(url => url)
            };
        } else if (pageType === 'product' && product) {
            // Product structured data
            structuredData = {
                "@context": "https://schema.org",
                "@type": "Product",
                "name": typeof product.name === 'object' ? product.name.en || product.name.ar : product.name,
                "description": product.description || storeDescription,
                "image": product.images?.[0] || logoUrl,
                "brand": {
                    "@type": "Brand",
                    "name": storeName
                },
                "offers": {
                    "@type": "Offer",
                    "price": product.price || "0",
                    "priceCurrency": storeSettings.currency || "USD",
                    "availability": product.stock > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
                    "seller": {
                        "@type": "Organization",
                        "name": storeName
                    }
                }
            };
        } else if (pageType === 'shop') {
            // Store/Shop structured data
            structuredData = {
                "@context": "https://schema.org",
                "@type": "Store",
                "name": storeName,
                "description": storeDescription,
                "url": currentUrl,
                "image": logoUrl
            };
        }

        // Remove existing structured data
        const existingScript = document.querySelector('#structured-data');
        if (existingScript) {
            existingScript.remove();
        }

        // Add new structured data
        if (structuredData) {
            const script = document.createElement('script');
            script.id = 'structured-data';
            script.type = 'application/ld+json';
            script.textContent = JSON.stringify(structuredData);
            document.head.appendChild(script);
        }

        // Cleanup function
        return () => {
            const scriptToRemove = document.querySelector('#structured-data');
            if (scriptToRemove) {
                scriptToRemove.remove();
            }
        };
    }, [storeSettings, loading, pageType, product]);

    return null;
};

export default StructuredData;